module.exports = __webpack_public_path__ + "static/cx-slider4-c4b36b91271cd0654fc170d967366ebd.jpeg";